'use strict';
import classNames from 'classnames';
import get from 'lodash/get';
import noop from 'lodash/noop';
import * as T from 'prop-types';
import React, {Fragment} from 'react';
import {Button} from '../../../components/buttons/Button';
import {ListItem} from '../../../components/lists/ListItem';
import {StatelessStatusSelector} from '../../../core-components/selectors/components/StatelessStatusSelector';
import {SvgIcons} from '../../../core-components/svg-menu-icons/icons';
import {SvgIcon} from '../../../core-components/svg-menu-icons/SvgIcon';
import {getGradientColor} from '../../../core-utilities/domain/AvatarColors';
import {I18nComponent} from '../../../core-utilities/react-i18n';
import {Image} from '../../../files/components/Image';
import {getFileRequirementMetrics} from '../../../projects/components/AssetProjectItem';
import {ASSET_PROJECT_COLLECTION} from '../../../projects/domain/AssetProjectDomain';
import {ASSET_COLLECTION} from '../../domain/AssetDomain';


export function BaseAssetCardView(props) {
  const isAsset = props.model.collection === ASSET_COLLECTION;
  const model = props.model;
  const asset = isAsset ? model : model.asset;
  const assetProject = isAsset ? null : model;
  const tempGeo = get(asset, 'geo') ? get(asset, 'geo') : null;
  const imgUrl = get(asset, 'avatar.url');
  const gradientColors = getGradientColor(asset.avc);

  let address;
  try {
    address = JSON.parse(tempGeo).properties.address;
  } catch (e) {
    address = null;
  }
  // TODO: set displayWidth and displayHeight according to card size
  // TODO: we should probably disable loading the image entirely on smaller screens
  return (
    <ListItem
      className={classNames("AssetCard", props.className)}
      bindParam={model}
      onClick={isAsset ? props.onNavToOverview : props.onNavToTasks}
    >
      <div
        className="AssetCard__imageWrapper"
      >
        {imgUrl ? (
          <Image
            className="AssetCard__image"
            title={props.title}
            url={imgUrl}
            // displayWidth={512} TODO:
            // displayHeight={512} TODO:
            crop={true}
            // targetWidth={512} TODO:
            // targetHeight={512} TODO:
          />
        ) : renderImagePlaceholder(gradientColors, false)}
      </div>
      <div className="AssetCard__content">
        <div className="AssetCard__header">
          {imgUrl ? (
            <Image
              className="AssetCard__smallImagePlaceholder"
              title={props.title}
              url={imgUrl}
              displayWidth={32}
              displayHeight={32}
              crop={true}
              targetWidth={44}
              targetHeight={44}
            />
          ) : renderImagePlaceholder(gradientColors, true)}
          <div className="AssetCard__nameWrapper">
            {asset.name ? (
              <span className="AssetCard__name">
                {asset.name}
              </span>
            ) : null}
          </div>
          {address && (
            <span className="AssetCard__address">
              {address}
            </span>
          )}
        </div>

        {asset.identifier ? (
          <span className="AssetCard__nameWrapper AssetCard__identifier">
            {`ID: ${asset.identifier}`}
          </span>
        ) : null}

        <div className="AssetCard__dataTags">
          {model.tags && model.tags.map(tag => `#${tag}`).join(', ')}
        </div>

        <div className="AssetCard__footer">

          {renderButton({
            label: props.overviewLabel,
            model: props.model,
            onClick: props.onNavToOverview,
            svgIcon: SvgIcons.Home,
          })}

          {isAsset ? null : renderButton({
            label: props.tasksLabel,
            model: props.model,
            onClick: props.onNavToTasks,
            svgIcon: SvgIcons.Tasks,
          })}

          <div className="AssetCard__metricsWrapper">
            {isAsset && asset.metrics ? (
              <div className="AssetCard__metrics">
                {props.projectsCountLabel}
              </div>
            ) : null}
            {!isAsset ? (
              <Fragment>
                <span>
                  {`${props.statusLabel}: `}
                </span>
                <StatelessStatusSelector
                  className="AssetCard__status"
                  labelClassName="AssetCard__status__label"
                  model={assetProject}
                  readOnly={true}
                  hasPermission={noop}
                  getStatusPermission={noop}
                  hideValue={false}

                  status={assetProject.status}
                  collection={ASSET_PROJECT_COLLECTION}
                />
                <div className="AssetCard__metrics">
                  <SvgIcon
                    className="AssetCard__metrics__svgIcon"
                    icon={SvgIcons.Folder}
                  />
                  <span className="AssetCard__metrics__label">
                    {getFileRequirementMetrics(assetProject.metrics)}
                  </span>
                </div>
              </Fragment>
            ) : null}
          </div>

        </div>
      </div>
    </ListItem>
  );
}

function renderImagePlaceholder(gradientColors, isSmall) {
  return (
    <div
      className={isSmall ? "AssetCard__smallImagePlaceholder" : "AssetCard__imagePlaceholder"}
      style={{background: `linear-gradient(to top right, ${gradientColors[0]}, ${gradientColors[1]}`}}
    >
      <SvgIcon
        className="AssetCard__imagePlaceholder__svgIcon"
        icon={SvgIcons.Asset}
      />
    </div>
  );
}

function renderButton(data) {
  const {
    label,
    model,
    onClick,
    svgIcon,
  } = data;
  return (
    <Button
      className="AssetCard__navButton"
      label={label}
      bindParam={model}
      onClick={onClick}
    >
      <SvgIcon
        className="AssetCard__navButton__svgIcon"
        icon={svgIcon}
      />
    </Button>
  );
}

BaseAssetCardView.propTypes = {
  className: T.string,
  model: T.object.isRequired,

  statusLabel: T.string,
  overviewLabel: T.string,
  tasksLabel: T.string,
  projectsCountLabel: T.string,

  onNavToOverview: T.func,
  onNavToTasks: T.func,
};

export const AssetCardView = I18nComponent(BaseAssetCardView, [
  {code: 'status.label', prop: 'statusLabel'},
  {code: 'default.tabs.overview.title', prop: 'overviewLabel'},
  {code: 'projects.tabs.tasks.list.title', prop: 'tasksLabel'},
  {code: 'assets.card.metrics.projects.label', prop: 'projectsCountLabel', params: getProjectCountParams},
]);

function getProjectCountParams(props) {
  return {
    count: get(props, 'model.metrics.projectsTotal', 0),
  };
}



// WEBPACK FOOTER //
// ./src/js/assets/components/AssetCard/AssetCardView.js